/* eslint-disable */

/*
Copyright 2010-2016 Mike Bostock
All rights reserved.

Redistribution and use in source and binary forms, with or without modification,
are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above copyright notice, this
  list of conditions and the following disclaimer.

* Redistributions in binary form must reproduce the above copyright notice,
  this list of conditions and the following disclaimer in the documentation
  and/or other materials provided with the distribution.

* Neither the name of the author nor the names of contributors may be used to
  endorse or promote products derived from this software without specific prior
  written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.


This code is based on
https://github.com/d3/d3-force/blob/master/src/manyBody.js
and modified to contain only horizontal force
*/

import { quadtree } from 'd3-quadtree';
import constant from 'd3-force/src/constant';
import jiggle from 'd3-force/src/jiggle';
import { x, y } from 'd3-force/src/simulation';

export default function () {
  var nodes,
    node,
    alpha,
    strength = constant(-30),
    strengths,
    distanceMin2 = 1,
    distanceMax2 = Infinity,
    theta2 = 0.81;

  function force(_) {
    var i,
      n = nodes.length,
      tree = quadtree(nodes, x, y).visitAfter(accumulate);
    for (alpha = _, i = 0; i < n; ++i) (node = nodes[i]), tree.visit(apply);
  }

  function initialize() {
    if (!nodes) return;
    var i,
      n = nodes.length,
      node;
    strengths = new Array(n);
    for (i = 0; i < n; ++i)
      (node = nodes[i]), (strengths[node.index] = +strength(node, i, nodes));
  }

  function accumulate(quad) {
    var strength = 0,
      q,
      c,
      weight = 0,
      x,
      y,
      i;

    // For internal nodes, accumulate forces from child quadrants.
    if (quad.length) {
      for (x = y = i = 0; i < 4; ++i) {
        if ((q = quad[i]) && (c = Math.abs(q.value))) {
          (strength += q.value), (weight += c), (x += c * q.x);
        }
      }
      quad.x = x / weight;
    }

    // For leaf nodes, accumulate forces from coincident quadrants.
    else {
      q = quad;
      q.x = q.data.x;
      q.y = q.data.y;
      do strength += strengths[q.data.index];
      while ((q = q.next));
    }

    quad.value = strength;
  }

  function apply(quad, x1, _, x2) {
    if (!quad.value) return true;

    var x = quad.x - node.x,
      w = x2 - x1,
      l = x * x;

    // Apply the Barnes-Hut approximation if possible.
    // Limit forces for very close nodes; randomize direction if coincident.
    if ((w * w) / theta2 < l) {
      if (l < distanceMax2) {
        if (x === 0) (x = jiggle()), (l += x * x);
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        node.vx += (x * quad.value * alpha) / l;
      }
      return true;
    }

    // Otherwise, process points directly.
    else if (quad.length || l >= distanceMax2) return;

    // Limit forces for very close nodes; randomize direction if coincident.
    if (quad.data !== node || quad.next) {
      if (x === 0) (x = jiggle()), (l += x * x);
      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
    }

    do
      if (quad.data !== node) {
        w = (strengths[quad.data.index] * alpha) / l;
        node.vx += x * w;
      }
    while ((quad = quad.next));
  }

  force.initialize = function (_) {
    nodes = _;
    initialize();
  };

  force.strength = function (_) {
    return arguments.length
      ? ((strength = typeof _ === 'function' ? _ : constant(+_)),
        initialize(),
        force)
      : strength;
  };

  force.distanceMin = function (_) {
    return arguments.length
      ? ((distanceMin2 = _ * _), force)
      : Math.sqrt(distanceMin2);
  };

  force.distanceMax = function (_) {
    return arguments.length
      ? ((distanceMax2 = _ * _), force)
      : Math.sqrt(distanceMax2);
  };

  force.theta = function (_) {
    return arguments.length ? ((theta2 = _ * _), force) : Math.sqrt(theta2);
  };

  return force;
}
